<zenith-card class="mt-3">
  <zenith-card-content>
    <h3>{{ 'components.instance.technical-details.title' | translate }}</h3>

    @if (instance.technicalDetails.grossVehicleWeight) {
      <zenith-table class="mt-4">
        <zenith-table-header-row>
          <zenith-table-header-cell>{{ 'components.instance.technical-details.weight' | translate }}</zenith-table-header-cell>
          <zenith-table-header-cell><!-- TODO: workaround until support for zn-colspan (ZNT-1448) is implemented --></zenith-table-header-cell>
        </zenith-table-header-row>
        <zenith-table-row>
          <zenith-table-cell>{{ 'components.instance.technical-details.weight' | translate }}:</zenith-table-cell>
          <zenith-table-cell>{{ instance.technicalDetails.grossVehicleWeight.value }} {{ 'enum.UnitOfMeasurement.' + instance.technicalDetails.grossVehicleWeight.unit + '.short' | translate }}</zenith-table-cell>
        </zenith-table-row>
      </zenith-table>
    }

    <zenith-table>
      <zenith-table-header-row>
        <zenith-table-header-cell>{{ 'components.instance.technical-details.transport' | translate }}</zenith-table-header-cell>
        <zenith-table-header-cell><!-- TODO: workaround until support for zn-colspan (ZNT-1448) is implemented --></zenith-table-header-cell>
      </zenith-table-header-row>
      @if (instance.technicalDetails.minimumTransportHeight) {
        <zenith-table-row>
          <zenith-table-cell>{{ 'components.instance.technical-details.height' | translate }}:</zenith-table-cell>
          <zenith-table-cell>{{ instance.technicalDetails.minimumTransportHeight.value }} {{ 'enum.UnitOfMeasurement.' + instance.technicalDetails.minimumTransportHeight.unit + '.short' | translate }}</zenith-table-cell>
        </zenith-table-row>
      }
      @if (instance.technicalDetails.minimumTransportLength) {
        <zenith-table-row>
          <zenith-table-cell>{{ 'components.instance.technical-details.length' | translate }}:</zenith-table-cell>
          <zenith-table-cell>{{ instance.technicalDetails.minimumTransportLength.value }} {{ 'enum.UnitOfMeasurement.' + instance.technicalDetails.minimumTransportLength.unit + '.short' | translate }}</zenith-table-cell>
        </zenith-table-row>
      }
      @if (instance.technicalDetails.minimumTransportWidth) {
        <zenith-table-row>
          <zenith-table-cell>{{ 'components.instance.technical-details.width' | translate }}:</zenith-table-cell>
          <zenith-table-cell>{{ instance.technicalDetails.minimumTransportWidth.value }} {{ 'enum.UnitOfMeasurement.' + instance.technicalDetails.minimumTransportWidth.unit + '.short' | translate }}</zenith-table-cell>
        </zenith-table-row>
      }
    </zenith-table>
  </zenith-card-content>
</zenith-card>
